const DECISIONS = new Set(['serviceable', 'not_serviceable', 'unknown']);

export function normalizeServiceabilityDecision(value) {
  return DECISIONS.has(value) ? value : 'unknown';
}

export function decisionFromServiceabilityFlag(value) {
  if (value === true) return 'serviceable';
  if (value === false) return 'not_serviceable';
  return 'unknown';
}
